











































import Vue from "vue";
import { ITravel } from "@/entities";
import { isEqual } from "lodash";
import { Prop, Component } from "vue-property-decorator";
const Details = () =>
  import("@/components/travel/group-travel-tabs/Details.vue");
const ExpectedTravel = () =>
  import("@/components/travel/group-travel-tabs/ExpectedTravel.vue");
const Escort = () => import("@/components/travel/group-travel-tabs/Escort.vue");
const AccommodationIndividual = () =>
  import("@/components/travel/group-travel-tabs/AccommodationIndividual.vue");
const PaidGroupTravel = () =>
  import("@/components/travel/group-travel-tabs/PaidGroupTravel.vue");

@Component({
  components: {
    Details,
    ExpectedTravel,
    Escort,
    AccommodationIndividual,
    PaidGroupTravel,
  },
})
//Mixins(viewMetaMixin, onLoadJumpMixin, onLocaleChangeMixin)
export default class TravelDescribeMenu extends Vue {
  @Prop() travelData?: ITravel | null;
  private tab = 0;

  get getTabIndex(): number {
    return this.tab;
  }

  get items(): any[] {
    return isEqual(this.travelData?.travel_format, "group")
      ? [
          { tab: this.$t("groupTravelTabs.expected"), content: ExpectedTravel },
          { tab: this.$t("groupTravelTabs.details"), content: Details },
          { tab: this.$t("groupTravelTabs.escort"), content: Escort },
          {
            tab: this.$t("groupTravelTabs.bookingPaid"),
            content: PaidGroupTravel,
          },
        ]
      : [
          { tab: this.$t("groupTravelTabs.expected"), content: ExpectedTravel },
          { tab: this.$t("groupTravelTabs.details"), content: Details },
          {
            tab: this.$t("individualTravel.accommodation"),
            content: AccommodationIndividual,
          },
          {
            tab: this.$t("groupTravelTabs.bookingPaid"),
            content: PaidGroupTravel,
          },
        ];
  }

  get tabStep(): boolean {
    return this.tab ? true : false;
  }

  private nextStep(): void {
    this.tab++;
  }

  private previousStep(): void {
    this.tab = this.tab - 1;
  }
}
